module.exports = __webpack_public_path__ + "img/SKMJ_lift3.75276f28.jpg";